import { Injectable } from '@angular/core';
import { ILicenseProviderService } from '@nimbus-library/features/feature-permission/services/contracts/i-license-provider.service';
import { ILicenseCollection } from '@nimbus-library/features/feature-permission/models/i-license-collection.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { ExchangeLicenses, LicenseSKU } from '@nimbus-portal/features/feature-permission/services/contact-license-capability.model';
import { AcO365LicenseResolver } from '@nimbus-portal/features/attendant-console/services/ac-o365-license-resolver';

@Injectable()
export class LicenseProviderService extends ILicenseProviderService {
  protected licenseCollectionDefinition: ILicenseCollection<LicenseSKU>[] = [
    {
      name: TranslationKeys.LicenseListO365LicenseName,
      licenses: [
        {
          values: ExchangeLicenses, /// Test purposes
          name: TranslationKeys.LicenseListO365LicenseExchangeName,
          description: TranslationKeys.LicenseListO365LicenseExchangeDescription,
          resolver: AcO365LicenseResolver,
          appliedMessage: '',
          notAppliedMessage: '',
        },
      ],
      icon: ICONS.LICENSE,
    },
  ];
}
